import { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { Button } from "@/src/components";
import { ConnectButton } from "@/src/components/connectButton";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { toast } from "react-hot-toast";
import { activeChain } from "@/src/configs/chainConfig";
import { useDaoVotes } from "@/src/hooks/useVotes";
import { fmt } from "@/src/lib/utils";

export const DaoVoteCard = () => {
  const { chain } = useAccount();
  const { onProposeChange, onDaoVote } = useStake();
  const { uncharged,charged, frbBalance } = useBalances();
  const { isConnected } = useAccount();
  const { eligibleVotes, vote_enabled, functionCalled, deadline, var1, var2, var3, var4, voteAmount } = useDaoVotes();

  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });
  const [{ _var1, _var2, _var3, _var4 }, setInput] = useState({
    _var1: 0,
    _var2: 0,
    _var3: "",
    _var4: "",
  });

  const onInputVar1 = (event) => {
    const value = event.target.value;
    setInput(prevState => ({
      ...prevState,
      _var1: value
    }));
  };
  const onInputVar3 = (event) => {
    const value = event.target.value;
    setInput(prevState => ({
      ...prevState,
      _var3: value
    }));
  };
  const onInputVar4 = (event) => {
    const value = event.target.value;
    setInput(prevState => ({
      ...prevState,
      _var4: value
    }));
  };

  const onChange = async (e) => {
    if (!isConnected) return;

    console.log(_var1);
    console.log(_var2);

    toast.promise(onProposeChange(e.currentTarget.id, _var1 , _var2, _var3, _var4), {
      loading: "Transaction is in progress",
      success: "Successfully proposed change",
      error: (data) => data,
    });
  }

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });

  }, [chain, isConnected]);

  const voteYes = async (event) => {
    event.preventDefault();
      return toast.promise(onDaoVote(1), {
        loading: "Transaction is in progress",
        success: "Successfully voted Yes",
        error: (data) => data,
      });
  };
  const voteNo = async (event) => {
    event.preventDefault();
      return toast.promise(onDaoVote(0), {
        loading: "Transaction is in progress",
        success: "Successfully voted No",
        error: (data) => data,
      });
  };
  return (
    <div className="space-y-5 max-w-xl mx-auto">
    <div className="border border-border w-full rounded-xl p-4 sm:p-6 space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">DAO Proposal Vote</h3>
        <span className={(vote_enabled && Date.now()/1000 < (parseInt(deadline))) ? "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-success/15 text-success" : "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-destructive/15 text-destructive"}>{(vote_enabled && Date.now()/1000 < (parseInt(deadline))) ? "Open" : "Closed"}</span>
      </div>

      {vote_enabled &&
      <>
      <div className="rounded-lg bg-secondary/30 p-4 space-y-3">
        <div className="flex items-center justify-between py-2.5 border-b border-border/50">
          <span className="text-sm text-muted-foreground">Function Called</span>
          <span className="text-foreground font-semibold text-sm">{functionCalled}</span>
        </div>
        {  var1 !== 0 && <div className="flex items-center justify-between py-2.5 border-b border-border/50"><span className="text-sm text-muted-foreground">Amount</span><span className="text-lg sm:text-2xl font-bold text-foreground font-mono">{fmt(var1, 0)}</span></div>}
        {  var2 !== 0 && <div className="flex items-center justify-between py-2.5 border-b border-border/50"><span className="text-sm text-muted-foreground">Parameter 2</span><span className="text-lg sm:text-2xl font-bold text-foreground font-mono">{fmt(var2, 0)}</span></div>}
        {  var3 !== "0x0000000000000000000000000000000000000000" && <div className="py-2.5 border-b border-border/50"><span className="text-sm text-muted-foreground">Destination Address</span><p className="text-foreground font-mono text-xs mt-1.5 break-all bg-secondary/50 rounded-lg px-3 py-2">{var3}</p></div> }
        {  var4 !== "0x0000000000000000000000000000000000000000" && <div className="py-2.5 last:border-0"><span className="text-sm text-muted-foreground">Parameter 4</span><p className="text-foreground font-mono text-xs mt-1.5 break-all bg-secondary/50 rounded-lg px-3 py-2">{var4}</p></div> }
      </div>
      </>
      }

      <div className="space-y-0">
        <div className="flex items-center justify-between py-2.5 border-b border-border/50">
          <span className="text-sm text-muted-foreground">Eligible votes</span>
          <span className="text-lg sm:text-2xl font-bold text-foreground font-mono">{parseInt(eligibleVotes)}</span>
        </div>
      </div>

        <div>
          {!isConnected && (
            <div className="flex justify-center">
              <ConnectButton />
            </div>
          )}
      </div>

      {isConnected && (
        <div className="grid grid-cols-2 gap-3 pt-2">
          <form onSubmit={voteYes}>
            <Button type="submit" value="1" disabled={!isCorrectChain || eligibleVotes===0 || vote_enabled===false } className="bg-success/15 text-success border border-success/30 hover:bg-success/25 hover:shadow-none w-full">Yes</Button>
          </form>
          <form onSubmit={voteNo}>
            <Button type="submit" value="0" disabled={!isCorrectChain || eligibleVotes===0 || vote_enabled===false } className="bg-destructive/15 text-destructive border border-destructive/30 hover:bg-destructive/25 hover:shadow-none w-full">No</Button>
          </form>
        </div>
      )}
    </div>

    <div className="border border-border w-full rounded-xl p-4 sm:p-6 space-y-6">
      <div>
        <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Propose Changes</h3>
        <p className="text-sm text-muted-foreground mt-2">{fmt(voteAmount, 0)} FRB and minimum 1 NFT is required to propose a change. This can be refunded when voted by the community.</p>
      </div>

      <div className="border-t border-border" />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Transfer FRB</h3>
        <input onChange={onInputVar1} placeholder="Amount of FRB (WEI format)" className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="number" required />
        <input onChange={onInputVar3} placeholder="Contract Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <Button id="transferFRB" onClick={onChange} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 || parseInt(frbBalance) < parseFloat(voteAmount).toFixed(0)} className="w-full">Propose Change</Button>
      </div>

      <div className="border-t border-border" />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Transfer LP Tokens</h3>
        <input onChange={onInputVar1} placeholder="Amount of LP Tokens (WEI format)" className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="number" required />
        <input onChange={onInputVar3} placeholder="Contract Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <Button id="transferLp" onClick={onChange} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 || parseInt(frbBalance) < parseFloat(voteAmount).toFixed(0)} className="w-full">Propose Change</Button>
      </div>

      <div className="border-t border-border" />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Transfer ERC20 Tokens</h3>
        <input onChange={onInputVar1} placeholder="Amount of ERC20 Tokens (WEI format)" className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="number" required />
        <input onChange={onInputVar3} placeholder="Destination Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <input onChange={onInputVar4} placeholder="ERC20 Token Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <Button id="transferERC20" onClick={onChange} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 || parseInt(frbBalance) < parseFloat(voteAmount).toFixed(0)} className="w-full">Propose Change</Button>
      </div>

      <div className="border-t border-border" />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Change owner of Airdrop Contract</h3>
        <input onChange={onInputVar3} placeholder="Contract Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <Button id="airdropTransferOwnership" onClick={onChange} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 || parseInt(frbBalance) < parseFloat(voteAmount).toFixed(0)} className="w-full">Propose Change</Button>
      </div>

      <div className="border-t border-border" />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Change owner of Rewards Contract</h3>
        <input onChange={onInputVar3} placeholder="Contract Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <Button id="rewardsTransferOwnership" onClick={onChange} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 || parseInt(frbBalance) < parseFloat(voteAmount).toFixed(0)} className="w-full">Propose Change</Button>
      </div>

      <div className="border-t border-border" />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Change owner of Token Contract</h3>
        <input onChange={onInputVar3} placeholder="Contract Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <Button id="frbTransferOwnership" onClick={onChange} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 || parseInt(frbBalance) < parseFloat(voteAmount).toFixed(0)} className="w-full">Propose Change</Button>
      </div>

      <div className="border-t border-border" />

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Migrate FRB, LP & contracts to new DAO contract</h3>
        <input onChange={onInputVar3} placeholder="Contract Address 0x..." className="w-full min-w-0 bg-secondary/50 border border-border rounded-xl px-3 sm:px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all" type="text" required />
        <Button id="migrate" onClick={onChange} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 || parseInt(frbBalance) < parseFloat(voteAmount).toFixed(0)} className="w-full">Propose Change</Button>
      </div>

   </div>

    </div>

  );
};
